import request from "@/utils/request";
import base from './base';

// 定义接口
// export const host = "http://127.0.0.1:8000"; // 代理请求
export const host = base.api_data;
//const api_store = "/store/get_store_list/"; // 商品档案列表
const api_region_tree = "/store/region_tree/"; //门店区域分组树 温州大区-温州一区  
const api_store_action = "/store/store_action/"; //门店操作
const api_store_check = "/store/store_check/"; //门店查重复
const api_store_save = "/store/store_save/"; //门店添加或修改

// 修改布局图相关接口常量
const api_store_layout = "/store/layout"; // 布局图基础路径
const api_store_layout_markers = "/store/layout/markers"; // 标注点操作

// 获取 token
const getToken = () => {
  return sessionStorage.getItem('token') || '';
};

// 获取门店布局图
export function getStoreLayout(storeId) {
  return request({
    url: `${host}${api_store_layout}/${storeId}/`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${getToken()}`
    }
  });
}

export function uploadStoreLayout(storeId, file, username) {
  const formData = new FormData();

  // 直接使用原始文件，不处理文件名
  formData.append('file', file);
  formData.append('username', username);

  console.log('准备上传:', {
    url: `${host}${api_store_layout}/${storeId}/`,
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    username: username
  });

  return request({
    url: `${host}${api_store_layout}/${storeId}/`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log('上传进度:', percentCompleted + '%');
    }
  });
}

export function deleteStoreLayout(storeId) {
  return request({
    url: `${host}${api_store_layout}/${storeId}/`,
    method: 'delete'
  });
}

export function saveLayoutMarkers(storeId, markers) {
  return request({
    url: `${host}${api_store_layout}/${storeId}/markers/`,
    method: 'post',
    data: { markers }
  });
}

// 获取布局图上传日志
export function getLayoutUploadLogs(params) {
  return request({
    url: `${host}${api_store_layout}/logs/`,
    method: 'get',
    params: params
  });
}

// 其他接口保持不变
export default {
  api_store(params) {
    return request.get(`${host}${api_store}`, params);
  },
  api_region_tree(params) {
    return request.get(`${host}${api_region_tree}`, params);
  },
  api_store_action(params, method = 'delete') {
    if (method === 'DELETE') {
      return request.delete(`${host}${api_store_action}`, { data: params });
    } else {
      const queryString = Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      return request.get(`${host}${api_store_action}?${queryString}`);
    }
  },
  api_store_check(params) {
    return request.post(`${host}${api_store_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
  },
  api_store_save(params) {
    return request.post(`${host}${api_store_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
  },
  // 获取门店布局图及标注信息
  getStoreLayout,
  // 上传门店布局图
  uploadStoreLayout,
  // 保存标注点信息
  saveLayoutMarkers,
  // 删除布局图
  deleteStoreLayout,
  getLayoutUploadLogs
};



